export enum BuyersActionTypes {
  SET_BUYERS = 'SET_BUYERS',
  SET_JOURNEY_DATA = 'SET_JOURNEY_DATA',
  SET_BUYER_CONTRACTS_DATA = 'SET_BUYER_CONTRACTS_DATA',
  CLEAR_BUYERS = 'CLEAR_BUYERS',
}

export type ContractType = 'PUBLIC' | 'PRIVATE'

interface BuyerInfo {
  companyName: string
  logoUrl: string
}

interface BuyerDetails {
  totalTcv: number
  renewal: string
  autoRenew: boolean
  buyerSince: string
  totalContracts: number
  activeContracts: number
  churnSignal: string
  awsCloudAccountIds: string[]
  awsCustomerIdentifierIds: string[]
  creatorNames: string[]
}

export interface JourneyStates {
  offerSent?: string
  offerAccepted?: string
  contractStarted?: string
  contractEnded?: string
  contractRenewal?: null
  offerAboSent?: string
  offerAboAccepted?: string
  contractUnsubscribed?: string
}

export interface JourneyContractDetails {
  contractName: string
  states: { contractId: string; states: JourneyStates }[]
}

export interface BuyerJourneyContracts {
  contractCreatedAt: string
  contractId: string
  contractName: string
  contractType: ContractType
}

interface Buyer {
  companyName: string
  domain: string
  labraBuyerDetailsId: string
  buyerInfo: BuyerInfo
  details: BuyerDetails
}

export interface BuyersData {
  buyers: Buyer[]
  buyerJourney: JourneyContractDetails
  buyerContracts: BuyerJourneyContracts[]
}

export const initialBuyersState: BuyersData = {
  buyers: [],
  buyerJourney: {} as JourneyContractDetails,
  buyerContracts: [],
}

export type BuyersAction =
  | {
      type: BuyersActionTypes.SET_BUYERS
      payload: BuyersData
    }
  | {
      type: BuyersActionTypes.SET_JOURNEY_DATA
      payload: JourneyContractDetails
    }
  | {
      type: BuyersActionTypes.SET_BUYER_CONTRACTS_DATA
      payload: BuyerJourneyContracts[]
    }
  | {
      type: BuyersActionTypes.CLEAR_BUYERS
    }
